import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import TimeInput from "../../input/time-input";

const Time1Widget = ({ widget, onValueUpdate }) => {
  const [v0, setV0] = useState(null);

  useEffect(() => {
    setV0(widget);
    return () => {};
  }, [widget]);

  const handleValueUpdate = (data) => {
    const updatedWidget = { ...v0, value: data };
    onValueUpdate(updatedWidget);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
        padding: "2px",
      }}
    >
      {v0 && <TimeInput valueSpec={v0} onChange={handleValueUpdate} />}
    </Box>
  );
};

export default Time1Widget;
